import Page from "webPage/Page";
import ImplementationPersonModal from "modal/ImplementationPersonModal";
import StickySection from "util/StickySection";
import $ from "jquery";
import {handleScrollingSection} from "util/scrolling-section";
import Track from "../util/Track";

Page.register('page-template-implementation', () => {
    $('body').on('click', '.js-person-modal', function () {
        let data = JSON.parse($(this).parent().find('.js-modal-data').text());
        (new ImplementationPersonModal(data)).show();
        return false;
    }).on('click', '.js-modal-close', function () {
        $(this).parents('.modal').remove();
        $('body').removeClass('modal-active');
        return false;
    });

    new StickySection($('.js-sticky-section'));
    handleScrollingSection($('.js-scrolling-logos'));
    handleScrollingSection($('.js-scrolling-logos-left'), "left");

    new Track($('.js-testimonials-track-wrap'), {
        classes: {
            block: "testimonials-track",
        },
    });
});
